import { render, staticRenderFns } from "./index.vue?vue&type=template&id=19092f86&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19092f86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19092f86')) {
      api.createRecord('19092f86', component.options)
    } else {
      api.reload('19092f86', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=19092f86&scoped=true", function () {
      api.rerender('19092f86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administrators/roleManage/index.vue"
export default component.exports